import { apiRequest } from "../apiRequest";

const pingSlackOnReportCreation = (data) => {
  return apiRequest("/zapier/reports-create", "POST", data);
};

const pingSlackonReportCreationError = (data) => {
  return apiRequest("/zapier/reports-error", "POST", data);
};

export { pingSlackOnReportCreation, pingSlackonReportCreationError };
